import React from 'react';

import { ListItem, ListItemText } from '@material-ui/core';

import styles from './SettingSectionTitle.module.scss';

export interface ISettingTitle {
	type: 'title';
	title: string;
	hidden?: boolean;
}

export const SettingSectionTitle: React.FC<ISettingTitle> = ({
	title,
	hidden = false,
}) => {
	if (hidden) {
		return null;
	}
	return (
		<div className={styles['setting-section']}>
			<div className={styles['setting-section-title']}>{title}</div>
		</div>
	);
};

export default SettingSectionTitle;
